import { render } from "./LoaderScreen.vue?vue&type=template&id=0b1e234f"
import script from "./LoaderScreen.vue?vue&type=script&lang=js"
export * from "./LoaderScreen.vue?vue&type=script&lang=js"

import "./LoaderScreen.vue?vue&type=style&index=0&id=0b1e234f&lang=css"

import exportComponent from "/Users/macbookpro/Desktop/thecustomer/st-daara/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__